import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface NavigationItem {
    name: string;
    active: boolean;
}

@Component({
    selector: 'ham-tab-navigation',
    template: `
        <div class="tab-navigation" [ngClass]="[style, color]">
            <span
                *ngFor="let item of navigationItems; let i = index"
                (click)="handleClick(item)"
                [ngClass]="{ active: item.active }"
            >
                {{ tabsTitles[i] }}
            </span>
        </div>
    `,
    styleUrls: ['./tab-navigation.component.scss'],
})
export class HamTabNavigationComponent {
    @Input() navigationItems: NavigationItem[] = [];
    @Input() tabsTitles: string[] = [];
    @Input() style: 'underline' | 'pills' | 'xs-pills' = 'underline'; // Options for styles
    @Input() color: 'primary' | 'secondary' = 'primary'; // Options for colors
    @Output() tabClick = new EventEmitter<NavigationItem>();

    handleClick(item: NavigationItem) {
        this.tabClick.emit(item); // Emit an event when a tab is clicked
    }
}
